import React from 'react'
import { useSearchParams } from 'react-router-dom'
import { Box, Text, Title } from '@mantine/core'

const CheckoutCompletePage = () => {
	const [searchParams] = useSearchParams()
	const status = searchParams.get('status')
	const isCanceled = status === 'canceled'

	return (
		<Box px='md' py='xl' maw={520} mx='auto'>
			<Title order={2} mb='sm'>
				{isCanceled ? 'Payment Canceled' : 'Payment Complete'}
			</Title>
			<Text color='dimmed' mb='lg'>
				{isCanceled
					? 'This checkout was canceled. You can close this tab and return to the check-in desk.'
					: 'You can close this tab and return to the check-in desk.'}
			</Text>
		</Box>
	)
}

export default CheckoutCompletePage
